<template>
  <div class="home">
    <b-row class="justify-content-md-center">
      <b-col cols="12" md="auto">
        <img class="mx-auto d-block" alt="idealive" src="../assets/logo-idealive.png">
        <h4 class="text-muted text-center">Sistema de Facturació</h4>
        <hr>
        <h4 class="text-primary text-center"></h4>
        <div v-if="!loggedIn">
          Identificarse per utilitzar el sistema:
          <router-link :to="{ name: 'Login'}">
            Login
          </router-link>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { authComputed } from '../store/helpers.js'
// @ is an alias to /src

export default {
  name: 'Home',
  computed: {
    ...authComputed
  },
  data: function () {
    return {
      // path:'logo-basf.jpg'
    }
  }

}
</script>
